<script>
  export let title = "default title";
  export let expenseTotal = 0;
</script>

<section class="main-title">
  <h2>{title} : ${expenseTotal}</h2>
</section>
